import { reduce } from "et3-type-guards";
import React from "react";
import getReportsStore from "../../../../stores/reports-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import ReportsPartition from "./ReportsPartition";

const PendingReports = withLiteObserverAndTheme(() => {
  const reportsData = getReportsStore().orderedPendingReports.get();
  const shouldShow = getReportsStore().isDefinedPendingReportsData.get();

  return shouldShow ? (
    <React.Fragment>
      {reportsData.map((partition) => {
        const reportedData = reduce(() => partition[1], {
          data: [],
          total: -1
        });

        return (
          <ReportsPartition
            data={reportedData.data}
            total={reportedData.total}
          />
        );
      })}
    </React.Fragment>
  ) : null;
});

export default PendingReports;
